import { BoxWrapper } from "../Wrappers/Wrappers"
import { FlexWrapper } from "../Wrappers/Wrappers"


export const Loader = (): JSX.Element => {
    return (
        <FlexWrapper 
            className='full-width full-height show-up'
            alignItems="center" 
            justifyContent="center"
        >
            <BoxWrapper>
                <div className="lds">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </BoxWrapper>
        </FlexWrapper>
    )
}